/** The backend returns the per-partner default campaign as a real row named "No campaign". */
export const isNoCampaignName = (name?: string | null): boolean =>
  !name?.trim() || /^\s*no campaign\s*$/i.test(name);
